module.exports = __webpack_public_path__ + "img/collection-memoireRingsRingsets.c3cc858.jpg";